const doc = [["/question/{1-20}", "/demographics", "/results"]];
module.exports = doc.length <= 1 ? doc[0] : doc;